<template>
  <span>
    <v-navigation-drawer
      app
      v-model="drawer"
      class="pb-5"
      width="280"
      :class="highContrast ? 'dark' : 'accent'"
      :color="highContrast ? 'dark' : 'accent'"
      :permanent="$vuetify.breakpoint.lgAndUp"
    >
      <v-toolbar
        flat
        class="transparent primary"
        height="160px"
        :class="highContrast ? 'dark' : 'primary'"
      >
        <v-list class="pa-0 primary">
          <div :class="highContrast ? 'dark' : 'primary'" class="version">
            {{ version }}
          </div>
          <div :class="highContrast ? 'dark' : 'primary'">
            <v-btn
              v-if="trocarBeneficiario && planos.length > 0"
              icon
              :color="highContrast ? 'dark' : 'primary'"
              @click="setTrocarBeneficiario()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-list-tile
            avatar
            to="/portal/perfil"
            class="pa-3"
            :class="highContrast ? 'dark' : 'primary'"
          >
            <v-list-tile-avatar color="white">
              <v-img :src="avatarUrl" alt="avatar"></v-img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                class="white--text text-no-wrap"
                style="max-width: 160px"
                >{{ dadosBeneficiario.nomeAbreviado }}</v-list-tile-title
              >
              <small class="caption white--text"
                >PERFIL
                <v-icon small color="white">keyboard_arrow_down</v-icon>
              </small>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-radio-group
        dark
        class="mt-0 pt-0 beneficario--selecao d-flex"
        v-if="trocarBeneficiario"
        v-model="numeroCartao"
        :class="{ loading: !planos.length > 0 }"
      >
        <template v-for="plano in planos">
          <v-list
            class="primary"
            :key="plano.plano"
            :class="highContrast ? 'dark' : 'primary'"
          >
            <v-list-tile>
              <v-list-tile-content>
                <span class="body-1 text-truncate" style="max-width: 240px"
                  >Contrato: <br />
                  {{ plano.contratoId }}: {{ plano.planoNomeComercial }}</span
                >
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="beneficiario in plano.beneficiarios">
              <v-list-tile :key="beneficiario.numeroCartao">
                <v-list-tile-content>
                  <v-layout row>
                    <v-radio
                      color="secondary"
                      :value="beneficiario.numeroCartao"
                    ></v-radio>
                    <v-flex
                      style="
                        line-height: 16px;
                        padding-top: 4px;
                        margin-left: -16px;
                      "
                    >
                      <p class="body-2 text-truncate mb-0">
                        {{ beneficiario.nome }}
                      </p>
                      <small>
                        {{ beneficiario.titular ? "Titular" : "Dependente" }}
                        ({{ beneficiario.ativo ? "Ativo" : "Inativo" }})</small
                      >
                    </v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </template>
      </v-radio-group>
      <v-list class="menu--lateral" :class="highContrast ? 'dark' : 'accent'">
        <item-menu to="/portal" title="Início" icon="ico_home"></item-menu>
        <v-list-group v-for="(item, index) in menu" :key="index">
          <template v-slot:activator>
            <v-img
              :src="carregaIcones(item.title)"
              contain
              height="24"
              width="24"
              max-width="56"
            ></v-img>
            <v-list-tile>
              <v-list-tile-title :class="{ 'primary--text': !highContrast }">
                {{ item.title }}</v-list-tile-title
              >
            </v-list-tile>
          </template>
          <div v-for="(child, index) in item.childs" :key="index">
            <item-menu
              :title="child.title"
              :to="child.to"
              v-if="mostraMenu(child.to.name)"
            >
            </item-menu>
          </div>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app :color="highContrast ? 'dark' : 'secondary'" dark>
      <v-toolbar-side-icon
        class="hidden-lg-and-up"
        @click="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <router-link to="/portal">
        <v-img
          :src="logotipo"
          :width="$vuetify.breakpoint.mdAndUp ? '126' : '84'"
          :height="$vuetify.breakpoint.mdAndUp ? '45' : '30'"
          :max-width="$vuetify.breakpoint.mdAndUp ? '126' : '84'"
          contain
          v-if="!highContrast && !carregandoLogo"
        ></v-img>
        <v-img
          :src="logotipo"
          :width="$vuetify.breakpoint.mdAndUp ? '126' : '84'"
          :height="$vuetify.breakpoint.mdAndUp ? '45' : '30'"
          :max-width="$vuetify.breakpoint.mdAndUp ? '126' : '84'"
          contain
          v-if="highContrast && !carregandoLogo"
        ></v-img>
      </router-link>
      <v-spacer></v-spacer>
      <accessibility></accessibility>
    </v-toolbar>
  </span>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { version } from "../../package.json";

import AvatarUrl from "@/assets/icons/ico_usuario-30.svg";

import { PARAMETROS } from "@/constants";
import Accessibility from "@/components/Accessibility";
import ItemMenu from "@/components/ItemMenu";

import { getParametro } from "@/services/beneficiario";
import { getAvatar } from "@/services/usuario";

import { isMenorDeIdade } from "@/utils/date";
import { getLogoCartao } from "../services/movimentos";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "AppNavigation",
  components: {
    Accessibility,
    ItemMenu
  },
  data() {
    return {
      numeroCartao: null,
      drawer: false,
      planos: [],
      pessoas: [],
      version,
      menu: [],
      inicializando: true,
      mostraMenuExtratoPormenorizado: false,
      mostraMenuDependente: {},
      mostraMenuCartaPortabilidade: null,
      logotipo: null,
      carregandoLogo: true
    };
  },
  computed: {
    ...beneficiarioStore.mapState([
      "avatarUrl",
      "dadosBeneficiario",
      "familiaPessoa",
      "trocarBeneficiario"
    ]),
    ...portalStore.mapState(["highContrast"]),
    getFaturaContra() {
      return this.dadosBeneficiario?.faturaContra === "T";
    }
  },
  watch: {
    numeroCartao: {
      handler() {
        this.verificaBeneficiarioDependente(this.numeroCartao);
        this.trocaBeneficiario(this.numeroCartao);
        this.validaAcessoRota();
      }
    },
    drawer: {
      handler() {
        if (!this.drawer) {
          this.setTrocarBeneficiario(this.drawer);
        }
      }
    },
    trocarBeneficiario: {
      handler() {
        if (this.trocarBeneficiario) {
          this.drawer = this.trocarBeneficiario;
        }
      }
    }
  },
  mounted() {
    this.numeroCartao = this.dadosBeneficiario.numeroCartao;
    this.getAvatar();
    this.getBeneficiarios();
  },
  async created() {
    this.setAvatarUrl(AvatarUrl);
    this.mostraMenuDependente = this.dadosBeneficiario.titular;
    const [
      exibeExtratoPormenorizado,
      parametroCartaPortabilidade
    ] = await Promise.all([
      this.exibeExtratoPormenorizado(),
      getParametro(PARAMETROS.EXIBIR_MENU_CARTA_PORTABILIDADE)
    ]);

    this.mostraMenuExtratoPormenorizado = exibeExtratoPormenorizado;
    this.mostraMenuCartaPortabilidade = parametroCartaPortabilidade;
    const menuStorage = JSON.parse(global.localStorage.menu);

    if (menuStorage.length) {
      this.menu = this.buildMenu(menuStorage[0].itens);
    }

    this.inicializando = false;
    getLogoCartao().then(response => {
      if (response && response.size !== 0) {
        const reader = new FileReader();
        reader.onload = () => {
          this.logotipo = reader.result;
          this.carregandoLogo = false;
        };
        reader.readAsDataURL(response);
      } else {
        this.logotipo = require("../assets/unimed-logo-1.png");
        this.carregandoLogo = false;
      }
    });
  },
  methods: {
    ...beneficiarioStore.mapMutations([
      "setAvatarUrl",
      "setTrocarBeneficiario",
      "setDadosBeneficiario"
    ]),
    validaAcessoRota() {
      if (this.inicializando) return;

      const rota = this.$route?.name;

      if (!this.mostraMenu(rota)) {
        this.$router.push({
          name: "home"
        });
      }
    },
    async exibeExtratoPormenorizado() {
      const parametroDisponibilizaExtratoPormenorizado =
        (await getParametro(
          PARAMETROS.DISPONIBILIZAR_EXTRATO_PORMENORIZADO
        )) === "true";

      return (
        !this.dadosBeneficiario.planoIndividualFamiliar &&
        parametroDisponibilizaExtratoPormenorizado
      );
    },
    getParametroValorConfiguracao() {
      const jsonValor = this.mostraMenuCartaPortabilidade;

      if (!jsonValor) {
        return false;
      }

      const config = JSON.parse(jsonValor);
      if (
        !config.planosNaoRegulamentados &&
        !config.todosPlanosContratos &&
        !config.configuracaoPorContrato
      ) {
        return false;
      }

      return (
        (config.planosNaoRegulamentados &&
          this.dadosBeneficiario?.planoRegulamentado === "N") ||
        config.todosPlanosContratos ||
        (config.configuracaoPorContrato?.includes(
          this.dadosBeneficiario?.contratoId
        ) ??
          false)
      );
    },
    verificaPlanoRegulamentado() {
      if (this.getParametroValorConfiguracao()) {
        return false;
      }

      return true;
    },
    verificaBeneficiarioDependente(numeroCartao) {
      var titular = this.familiaPessoa.find(f => f.titular == true);
      var benef = this.familiaPessoa.find(f => f.numeroCartao == numeroCartao);

      if (!titular) {
        if (
          this.familiaPessoa.filter(f => f.pessoaId === benef?.pessoaId)
            .length === this.familiaPessoa.length
        ) {
          this.mostraMenuDependente = true;
        }
      }

      if (
        titular?.pessoaId === benef.pessoaId ||
        this.familiaPessoa.filter(f => f.pessoaId === titular?.pessoaId)
          .length === this.familiaPessoa.length
      ) {
        this.mostraMenuDependente = true;
      } else {
        if (titular) {
          this.mostraMenuDependente =
            isMenorDeIdade(benef.dataNascimento) ||
            benef.dependenteIncapaz ||
            benef.titular;
        } else {
          this.mostraMenuDependente = true;
        }
      }
    },
    getAvatar() {
      getAvatar(this.$store);
    },
    getBeneficiarios() {
      if (this.familiaPessoa.length) {
        let planos = [];

        this.familiaPessoa.forEach(beneficiario => {
          const plano = planos.find(
            planoBeneficiario =>
              planoBeneficiario?.contratoId === beneficiario?.contratoId
          );

          if (!plano && beneficiario?.contratoId) {
            planos.push({
              contratoId: beneficiario.contratoId,
              planoNomeComercial: beneficiario.planoNomeComercial
            });
          }
        });

        planos.map(plano => {
          plano.beneficiarios = this.familiaPessoa
            .filter(
              beneficiario => beneficiario?.contratoId === plano?.contratoId
            )
            .sort((beneficiarioA, beneficiarioB) =>
              beneficiarioA === beneficiarioB ? 0 : beneficiarioA.ativo ? -1 : 1
            )
            .sort((beneficiarioA, beneficiarioB) =>
              beneficiarioA === beneficiarioB
                ? 0
                : beneficiarioA.titular
                ? -1
                : 1
            );
        });

        this.planos = planos;
      }
    },
    trocaBeneficiario(numeroCartao) {
      const dadosBeneficiario = this.familiaPessoa.filter(
        beneficiario => beneficiario.numeroCartao === numeroCartao
      )[0];

      this.setDadosBeneficiario(dadosBeneficiario);
    },
    buildMenu(menu) {
      return menu
        .filter(item => Boolean(item?.show))
        .map(item => {
          if (item.itens) {
            return {
              title: item.label,
              show: item.show,
              childs: this.buildMenu(item.itens)
            };
          }

          if (item) {
            return {
              title: item.label,
              to: { name: item.route },
              show: item.show
            };
          }
        });
    },
    possuiRotaNoMenu(rota, itens = this.menu) {
      return itens.some(
        item =>
          item.to?.name === rota ||
          (item.childs && this.possuiRotaNoMenu(rota, item.childs))
      );
    },
    mostraMenu(rota) {
      switch (rota) {
        case "extratoPormenorizado":
          return this.mostraMenuExtratoPormenorizado;

        case "valoresPlano":
          return this.possuiRotaNoMenu(rota);

        case "faturas":
        case "extratoDespesa":
        case "pinSS":
        case "relatorio dados titular":
        case "historicoUtilizacao":
        case "protocolos":
        case "movement":
        case "document":
          return this.mostraMenuDependente;

        case "relatorios":
          return this.getFaturaContra;

        case "updateRegistration":
          return this.dadosBeneficiario.ativo;

        case "planDelete":
          return (
            this.mostraMenuDependente &&
            this.dadosBeneficiario.ativo &&
            this.dadosBeneficiario.permiteExclusaoPlano
          );

        case "portabilityLetter":
          return this.verificaPlanoRegulamentado();

        default:
          return true;
      }
    },
    carregaIcones(nomeMenu) {
      switch (nomeMenu) {
        case "Minhas Finanças":
          return require("../assets/icons/ico_reembolso.svg");
        case "Meu Plano":
          return require("../assets/icons/ico_carteirinha.svg");
        case "Solicitações":
          return require("../assets/icons/ico_mais.svg");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../scss/loading.scss";

.beneficario--selecao {
  .v-input__control {
    width: 100% !important;
    .v-input__slot {
      margin-bottom: 0;
    }
    .v-messages {
      display: none;
    }
  }
}
.menu--lateral .v-list__tile {
  padding-left: 0px;
  padding-right: 8px;
}
.version {
  font-weight: bold;
  color: white;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
</style>
